import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase/config';

// 이미지를 Firebase Storage에 업로드하는 함수
export const uploadImageAsync = async (file: File, userId: string): Promise<string> => {
  try {
    // 앱과 정확히 동일한 경로 사용: users/{userId}/profile-photos/profile_{timestamp}.jpg
    const fileName = `profile_${Date.now()}.jpg`;
    const filePath = `users/${userId}/profile-photos/${fileName}`;
    
    // Storage 참조 생성
    const storageRef = ref(storage, filePath);
    
    // 파일 업로드
    const snapshot = await uploadBytes(storageRef, file);
    
    // 다운로드 URL 가져오기
    const downloadURL = await getDownloadURL(snapshot.ref);
    
    return downloadURL;
  } catch (error) {
    console.error('Image upload error:', error);
    throw new Error('Image upload failed.');
  }
};

// 포트폴리오 이미지를 Firebase Storage에 업로드하는 함수
export const uploadPortfolioImageAsync = async (file: File, userId: string): Promise<string> => {
  try {
    // 파일 확장자 추출 (기존 앱과 동일한 경로 사용)
    const fileExtension = file.name.split('.').pop();
    const fileName = `users/${userId}/images/portfolio_${Date.now()}.${fileExtension}`;
    
    // Storage 참조 생성
    const storageRef = ref(storage, fileName);
    
    // 파일 업로드
    const snapshot = await uploadBytes(storageRef, file);
    
    // 다운로드 URL 가져오기
    const downloadURL = await getDownloadURL(snapshot.ref);
    
    return downloadURL;
  } catch (error) {
    console.error('Portfolio image upload error:', error);
    throw new Error('Portfolio image upload failed.');
  }
};

// 이미지 파일을 Base64로 변환하는 함수 (미리보기용)
export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = error => reject(error);
  });
};

// 이미지 압축 함수
export const compressImage = (file: File, maxWidth: number = 800, quality: number = 0.8): Promise<File> => {
  return new Promise((resolve) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    
    img.onload = () => {
      // 비율 유지하면서 크기 조정
      const ratio = Math.min(maxWidth / img.width, maxWidth / img.height);
      const newWidth = img.width * ratio;
      const newHeight = img.height * ratio;
      
      canvas.width = newWidth;
      canvas.height = newHeight;
      
      // 이미지 그리기
      ctx?.drawImage(img, 0, 0, newWidth, newHeight);
      
      // 압축된 이미지를 Blob으로 변환
      canvas.toBlob((blob) => {
        if (blob) {
          const compressedFile = new File([blob], file.name, {
            type: file.type,
            lastModified: Date.now(),
          });
          resolve(compressedFile);
        } else {
          resolve(file);
        }
      }, file.type, quality);
    };
    
    img.src = URL.createObjectURL(file);
  });
};
